"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applySizeLimitation = exports.getLimitedSize = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var clamp_1 = tslib_1.__importDefault(require("lodash/clamp"));
function getLimitedSize(minimumSize, maximumSize, originalSize, deltaSize) {
    var newSize = originalSize + deltaSize;
    return clamp_1.default(newSize, minimumSize, maximumSize);
}
exports.getLimitedSize = getLimitedSize;
function getLimitReached(unlimitedSize, limitedSize, maximumSize) {
    var isLimited = limitedSize !== unlimitedSize;
    if (!isLimited) {
        return "none";
    }
    return unlimitedSize > maximumSize ? "max" : "min";
}
function applySizeLimitation(minimumSize, maximumSize, originalSize, deltaSize) {
    var unlimitedSize = originalSize + deltaSize;
    var limitedSize = clamp_1.default(unlimitedSize, minimumSize, maximumSize);
    return {
        limitedSize: limitedSize,
        unlimitedSize: unlimitedSize,
        isLimited: limitedSize !== unlimitedSize,
        limitReached: getLimitReached(unlimitedSize, limitedSize, maximumSize),
    };
}
exports.applySizeLimitation = applySizeLimitation;
//# sourceMappingURL=sizeLimiting.js.map